import { render, staticRenderFns } from "./ModalOverlay.vue?vue&type=template&id=048d1028&scoped=true&"
import script from "./ModalOverlay.vue?vue&type=script&lang=ts&"
export * from "./ModalOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./ModalOverlay.vue?vue&type=style&index=0&id=048d1028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048d1028",
  null
  
)

export default component.exports